import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import {
  GridLegacy as Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  TextField,
} from '@mui/material';
import LocationTypeSelector from '../selectors/LocationTypeSelector';
import { locationEquipmentNameValid } from '../../../../redux/constants/names';

const EditLocationDialog = ({ open, onSubmit, onClose, loc, allNames, loaded }) => {
  const [locationName, setLocationName] = useState(loc?.name);
  const [locationType, setLocationType] = useState(loc?.type);

  const handleClose = () => {
    onClose();
    setLocationName();
    setLocationType();
  };

  const newLocation = useMemo(() => !loc || !loc?.name, [loc]);
  const allOtherNames = useMemo(
    () => allNames.filter((name) => name !== loc?.name),
    [allNames, loc]
  );

  const handleSubmit = () => {
    const edittedLocation = { ...(loc || {}), new_name: locationName, type: locationType };
    onSubmit(edittedLocation);
    handleClose();
  };

  const disabled =
    !loaded ||
    !locationEquipmentNameValid(locationName, allOtherNames) ||
    !(locationType || loc?.type);
  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle>{newLocation ? 'New Location' : 'Edit Location'}</DialogTitle>
      <DialogContent>
        <Grid container item xs={12} direction="column">
          <TextField
            helperText={
              <>
                Please enter location name.
                <br />
                Name must only contain letters, numbers, spaces, and these special characters:
                .\+#:_,()&&apos;&quot;-
                <br />
                Location names must be unique within a building and cannot share a name with a
                published equipment
              </>
            }
            label="Name"
            value={locationName ?? loc?.name ?? ''}
            onChange={(event) => setLocationName(event.target.value)}
          />
        </Grid>
        <Grid container item xs={6} direction="column">
          <LocationTypeSelector
            disabled={!newLocation}
            value={locationType ?? loc?.type ?? ''}
            setValue={(value) => setLocationType(value)}
          />
        </Grid>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button variant="contained" onClick={handleSubmit} color="success" disabled={disabled}>
          Save
        </Button>
        <Button variant="contained" onClick={handleClose} color="error" disabled={!loaded}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state, { buildingId }) => {
  const {
    entities: {
      staging: { loaded, pointsByBuilding, equipmentByBuilding },
    },
  } = state;

  // Including filtered point as points
  return {
    loaded: loaded[buildingId ?? ''] ?? false,
    pointsByTopic: pointsByBuilding[buildingId ?? ''] ?? {},
    allEquipment: equipmentByBuilding[buildingId ?? ''] ?? [],
  };
};

export default connect(mapStateToProps)(EditLocationDialog);
